import { COMPANY_FILTER_CHANGE } from 'containers/PartnerOptions/constants'

import {
  CLOSE_DRAWER,
  CLOSE_REMOVE_CONFIRM,
  CREATE_DESTINATION_ASYNC,
  DEACTIVATE_DESTINATION_DONE,
  DEACTIVATE_DESTINATION_LOADING,
  DELETE_DESTINATION_ASYNC,
  FETCH_DESTINATION_ASYNC,
  FETCH_DESTINATIONS_ASYNC,
  OPEN_DRAWER,
  OPEN_REMOVE_CONFIRM,
  UPDATE_DESTINATION_ASYNC,
} from './constants'

export default function () {
  const initialState = {
    destinations: [],
    catalogLoader: false,
    catalogError: null,

    drawerOpen: false,
    drawerMode: null,
    drawerDestinationId: null,
    drawerData: null,
    drawerLoader: false,
    drawerError: null,
    drawerSaving: false,

    deactivateLoading: false,

    removeConfirmOpen: false,
    removeDestinationId: null,
    removeLoading: false,
    removeError: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case COMPANY_FILTER_CHANGE:
        return { ...initialState }

      case FETCH_DESTINATIONS_ASYNC.INITIATE:
        return { ...state, catalogLoader: true, catalogError: null }
      case FETCH_DESTINATIONS_ASYNC.SUCCESS:
        return { ...state, catalogLoader: false, destinations: action.payload.data }
      case FETCH_DESTINATIONS_ASYNC.ERROR:
        return { ...state, catalogLoader: false, catalogError: action.error }

      case FETCH_DESTINATION_ASYNC.INITIATE:
        return { ...state, drawerLoader: true, drawerData: null, drawerError: null }
      case FETCH_DESTINATION_ASYNC.SUCCESS:
        return { ...state, drawerLoader: false, drawerData: action.payload.data }
      case FETCH_DESTINATION_ASYNC.ERROR:
        return { ...state, drawerLoader: false, drawerError: action.error }

      case CREATE_DESTINATION_ASYNC.INITIATE:
      case UPDATE_DESTINATION_ASYNC.INITIATE:
        return { ...state, drawerSaving: true, drawerError: null }
      case CREATE_DESTINATION_ASYNC.SUCCESS:
      case UPDATE_DESTINATION_ASYNC.SUCCESS:
        return { ...state, drawerSaving: false, drawerOpen: false }
      case CREATE_DESTINATION_ASYNC.ERROR:
      case UPDATE_DESTINATION_ASYNC.ERROR:
        return { ...state, drawerSaving: false, drawerError: action.error }

      case DEACTIVATE_DESTINATION_LOADING:
        return { ...state, deactivateLoading: true }
      case DEACTIVATE_DESTINATION_DONE:
        return { ...state, deactivateLoading: false }

      case DELETE_DESTINATION_ASYNC.INITIATE:
        return { ...state, removeLoading: true, removeError: null }
      case DELETE_DESTINATION_ASYNC.SUCCESS:
        return {
          ...state,
          removeLoading: false,
          removeConfirmOpen: false,
          removeDestinationId: null,
          removeError: null,
        }
      case DELETE_DESTINATION_ASYNC.ERROR:
        return { ...state, removeLoading: false, removeError: action.error }

      case OPEN_DRAWER:
        return {
          ...state,
          drawerOpen: true,
          drawerMode: action.payload.mode,
          drawerDestinationId: action.payload.destinationId,
          drawerData: action.payload.initialData || null,
          drawerError: null,
        }
      case CLOSE_DRAWER:
        return { ...state, drawerOpen: false, drawerData: null, drawerError: null }

      case OPEN_REMOVE_CONFIRM:
        return {
          ...state,
          removeConfirmOpen: true,
          removeDestinationId: action.payload.destinationId,
          removeError: null,
        }
      case CLOSE_REMOVE_CONFIRM:
        return { ...state, removeConfirmOpen: false, removeDestinationId: null, removeError: null }

      default:
        return state
    }
  }
}
